"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = void 0;
require('jsdom-global')();
const mark_parser_1 = __importDefault(require("@gojipress/mark-parser"));
const mark_renderer_html_1 = __importDefault(require("@gojipress/mark-renderer-html"));
const mark_renderer_react_1 = __importDefault(require("@gojipress/mark-renderer-react"));
const unorderedListItem_1 = __importDefault(require("./plugins/parsers/block/container/unorderedListItem"));
const codeBlock_1 = __importDefault(require("./plugins/parsers/block/leaf/codeBlock"));
const heading_1 = __importDefault(require("./plugins/parsers/block/leaf/heading"));
const thematicBreak_1 = __importDefault(require("./plugins/parsers/block/leaf/thematicBreak"));
const custom_1 = __importDefault(require("./plugins/parsers/block/leaf/custom"));
const codeSpan_1 = __importDefault(require("./plugins/parsers/inline/codeSpan"));
const emphasis_1 = __importDefault(require("./plugins/parsers/inline/emphasis"));
const strong_1 = __importDefault(require("./plugins/parsers/inline/strong"));
const link_1 = __importDefault(require("./plugins/parsers/inline/link"));
const image_1 = __importDefault(require("./plugins/parsers/inline/image"));
const video_1 = __importDefault(require("./plugins/parsers/inline/video"));
const iframe_1 = __importDefault(require("./plugins/parsers/inline/iframe"));
const mark_plugin_parser_inline_latex_1 = __importDefault(require("@gojipress/mark-plugin-parser-inline-latex"));
const unorderedListItem_2 = __importDefault(require("./plugins/renderers/sh/unorderedListItem"));
const blankLine_1 = __importDefault(require("./plugins/renderers/sh/blankLine"));
const paragraph_1 = __importDefault(require("./plugins/renderers/sh/paragraph"));
const codeBlock_2 = __importDefault(require("./plugins/renderers/sh/codeBlock"));
const heading_2 = __importDefault(require("./plugins/renderers/sh/heading"));
const text_1 = __importDefault(require("./plugins/renderers/sh/text"));
const thematicBreak_2 = __importDefault(require("./plugins/renderers/sh/thematicBreak"));
const strong_2 = __importDefault(require("./plugins/renderers/sh/strong"));
const emphasis_2 = __importDefault(require("./plugins/renderers/sh/emphasis"));
const codeSpan_2 = __importDefault(require("./plugins/renderers/sh/codeSpan"));
const literal_1 = __importDefault(require("./plugins/renderers/sh/literal"));
const custom_2 = __importDefault(require("./plugins/renderers/sh/custom"));
const link_2 = __importDefault(require("./plugins/renderers/sh/link"));
const image_2 = __importDefault(require("./plugins/renderers/sh/image"));
const video_2 = __importDefault(require("./plugins/renderers/sh/video"));
const iframe_2 = __importDefault(require("./plugins/renderers/sh/iframe"));
const mark_plugin_renderer_sh_latexinline_1 = __importDefault(require("@gojipress/mark-plugin-renderer-sh-latexinline"));
const blankLine_2 = __importDefault(require("./plugins/renderers/react-sh/blankLine"));
const paragraph_2 = __importDefault(require("./plugins/renderers/react-sh/paragraph"));
const text_2 = __importDefault(require("./plugins/renderers/react-sh/text"));
const unorderedListItem_3 = __importDefault(require("./plugins/renderers/html/unorderedListItem"));
const blankLine_3 = __importDefault(require("./plugins/renderers/html/blankLine"));
const paragraph_3 = __importDefault(require("./plugins/renderers/html/paragraph"));
const codeBlock_3 = __importDefault(require("./plugins/renderers/html/codeBlock"));
const heading_3 = __importDefault(require("./plugins/renderers/html/heading"));
const text_3 = __importDefault(require("./plugins/renderers/html/text"));
const thematicBreak_3 = __importDefault(require("./plugins/renderers/html/thematicBreak"));
const strong_3 = __importDefault(require("./plugins/renderers/html/strong"));
const emphasis_3 = __importDefault(require("./plugins/renderers/html/emphasis"));
const codeSpan_3 = __importDefault(require("./plugins/renderers/html/codeSpan"));
const custom_3 = __importDefault(require("./plugins/renderers/html/custom"));
const link_3 = __importDefault(require("./plugins/renderers/html/link"));
const image_3 = __importDefault(require("./plugins/renderers/html/image"));
const video_3 = __importDefault(require("./plugins/renderers/html/video"));
const iframe_3 = __importDefault(require("./plugins/renderers/html/iframe"));
const mark_plugin_renderer_html_latexinline_1 = __importDefault(require("@gojipress/mark-plugin-renderer-html-latexinline"));
const definition_1 = __importDefault(require("./plugins/renderers/html/custom/definition"));
const splitPanes_1 = __importDefault(require("./plugins/renderers/html/custom/splitPanes"));
class GojiMark {
    constructor() {
        this.parser = new mark_parser_1.default();
        this.renderer = new mark_renderer_html_1.default();
        this.reactRenderer = new mark_renderer_react_1.default();
    }
    use(plugin) {
        if (plugin.pluginType === "parser") {
            this.parser.use(plugin);
        }
        if (plugin.pluginType === "renderer" || plugin.pluginType === "custom") {
            this.renderer.use(plugin);
        }
        if (plugin.pluginType === "react-renderer" || plugin.pluginType === "react-custom") {
            this.reactRenderer.use(plugin);
        }
    }
    init() {
        // If no plugins have been loaded for the parser, load the default set
        if ((this.parser.blockPlugins.length + this.parser.inlinePlugins.length) ===
            0) {
            GojiMark.defaults.plugins.parsers.forEach((plugin) => this.parser.use(plugin));
        }
        // If no plugins have been loaded for the renderer, load the default set (renders to HTML)
        if ((this.renderer.pluginMap.size + Object.keys(this.renderer.customPluginMap).length) === 0) {
            GojiMark.defaults.plugins.renderers.syntaxHighlighting.forEach((plugin) => this.renderer.use(plugin));
        }
    }
    convert(gm) {
        const parsedOutput = this.parser.parse(gm);
        const renderedOutput = this.renderer.render(parsedOutput);
        return renderedOutput;
    }
    convertToReact(gm) {
        const parsedOutput = this.parser.parse(gm);
        const renderedOutput = this.reactRenderer.renderReact(parsedOutput);
        return renderedOutput;
    }
    convertToHTMLString(gm) {
        const fragment = this.convert(gm);
        const div = document.createElement('div');
        div.appendChild(fragment.cloneNode(true));
        return div.innerHTML;
    }
}
exports.default = GojiMark;
GojiMark.defaults = {
    plugins: {
        parsers: [
            unorderedListItem_1.default,
            codeBlock_1.default,
            heading_1.default,
            thematicBreak_1.default,
            codeSpan_1.default,
            emphasis_1.default,
            strong_1.default,
            custom_1.default,
            link_1.default,
            image_1.default,
            video_1.default,
            iframe_1.default,
            mark_plugin_parser_inline_latex_1.default,
        ],
        renderers: {
            html: [
                unorderedListItem_3.default,
                blankLine_3.default,
                paragraph_3.default,
                codeBlock_3.default,
                heading_3.default,
                text_3.default,
                thematicBreak_3.default,
                strong_3.default,
                emphasis_3.default,
                codeSpan_3.default,
                custom_3.default,
                link_3.default,
                image_3.default,
                video_3.default,
                iframe_3.default,
                splitPanes_1.default,
                definition_1.default,
                mark_plugin_renderer_html_latexinline_1.default,
            ],
            syntaxHighlighting: [
                unorderedListItem_2.default,
                blankLine_1.default,
                paragraph_1.default,
                codeBlock_2.default,
                heading_2.default,
                text_1.default,
                thematicBreak_2.default,
                strong_2.default,
                emphasis_2.default,
                codeSpan_2.default,
                literal_1.default,
                custom_2.default,
                link_2.default,
                image_2.default,
                video_2.default,
                iframe_2.default,
                mark_plugin_renderer_sh_latexinline_1.default,
            ],
            reactSyntaxHighlighting: [
                blankLine_2.default,
                paragraph_2.default,
                text_2.default,
            ],
        },
    },
};
